import { render } from "./Scopes.vue?vue&type=template&id=949f5f90&scoped=true&ts=true"
import script from "./Scopes.vue?vue&type=script&lang=ts"
export * from "./Scopes.vue?vue&type=script&lang=ts"

import "./Scopes.vue?vue&type=style&index=0&id=949f5f90&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-949f5f90"]])

export default __exports__